/**
 * Wann eine magere Trefferliste den Sichtbarkeitsbereich aufmacht.
 *
 * Wer im Team-Bereich sucht, sucht meistens nicht „im Team" — er sucht einen
 * Kontakt. Bleiben die Treffer einstellig, ist die wahrscheinlichste Erklärung
 * nicht „den gibt es nicht", sondern „der gehört einem anderen Team oder
 * niemandem". Auf PROD trifft das den Normalfall: von 7786 Kontakten haben 2819
 * gar kein BO-Team und tauchen deshalb im Team-Bereich nie auf.
 *
 * Statt den Nutzer raten zu lassen, schaltet die Liste dann sichtbar auf
 * „Alle" um.
 *
 * Bewusst eine reine Funktion: die Regel hat mehrere Sperren, und die gehoeren
 * pruefbar an eine Stelle statt verteilt in einen Effekt.
 */

/** Ab wie vielen Treffern die Liste im gewaehlten Bereich bleibt. */
export const WENIG_TREFFER_SCHWELLE = 10;

export type ScopeWechselFrage = {
  /** Aktueller Bereich. Bei „all" gibt es nichts aufzumachen. */
  scope: string;
  /** Getrimmter, entprellter Suchbegriff. Leer ⇒ keine Suche, keine Automatik. */
  suchbegriff: string;
  /** Laeuft noch eine Anfrage? Waehrenddessen ist die Trefferzahl bedeutungslos. */
  laedt: boolean;
  /** Gesamttreffer laut Server (X-Total-Count); `null`, wenn unbekannt. */
  gesamt: number | null;
  /** Gibt es weitere Seiten? Fuellt die Luecke, wenn `gesamt` fehlt. */
  hatMehr: boolean;
  /** So viele Zeilen liegen vor — Rueckfallebene, wenn `gesamt` fehlt. */
  geladeneZeilen: number;
  /**
   * Suchbegriff, fuer den die Automatik bereits gelaufen ist ODER den der
   * Nutzer von Hand entschieden hat. Verhindert beides: das wiederholte
   * Umschalten und das Ueberfahren einer bewussten Wahl — sonst spraenge die
   * Liste sofort zurueck auf „Alle", sobald jemand waehrend derselben Suche
   * wieder auf „Team" klickt.
   */
  gesperrtFuer: string | null;
};

/** Trefferzahl fuer die Entscheidung — `null`, wenn sie sich nicht ermitteln laesst. */
function trefferzahl(f: ScopeWechselFrage): number | null {
  if (f.gesamt != null) return f.gesamt;
  // Ohne Gesamtzahl taugt die Zeilenzahl nur, wenn nichts mehr nachkommt.
  return f.hatMehr ? null : f.geladeneZeilen;
}

export function sollAufAlleWechseln(f: ScopeWechselFrage): boolean {
  if (f.scope === "all") return false;
  if (!f.suchbegriff) return false;
  if (f.laedt) return false;
  if (f.gesperrtFuer === f.suchbegriff) return false;

  const treffer = trefferzahl(f);
  if (treffer == null) return false;
  return treffer < WENIG_TREFFER_SCHWELLE;
}
